import {
  Button,
  Card,
  CardContent,
  Chip,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";

import type { InboundNetworkInvite, InviteTargetType } from "../../../types";

interface Props {
  invite: InboundNetworkInvite;
  onRespond: (
    inviteId: number,
    inviteTargetType: InviteTargetType,
    accepted: boolean,
  ) => void;
  loading: boolean;
}

export function InboundInviteCard(props: Props) {
  const { invite, onRespond, loading } = props;
  const isSupplierInvite = invite.invite_target_type === "SUPPLIER";

  const inviteMessage = isSupplierInvite
    ? "wants you to join their Supplier Network"
    : "wants to add you as a Customer";

  return (
    <Card>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack spacing={1}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body1" fontWeight="600">
                {invite.from_user_first_name} {invite.from_user_last_name} from{" "}
                {invite.from_company_name} {inviteMessage}
              </Typography>
              <Tooltip
                title={
                  isSupplierInvite
                    ? "They want you to be their supplier"
                    : "They want to be your supplier"
                }
              >
                <Chip
                  label={isSupplierInvite ? "Supplier" : "Customer"}
                  size="small"
                  color={isSupplierInvite ? "primary" : "secondary"}
                  variant="outlined"
                />
              </Tooltip>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              Sent: {new Date(invite.created_at).toLocaleDateString()}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              disabled={loading}
              onClick={() =>
                onRespond(invite.invite_id, invite.invite_target_type, true)
              }
            >
              Accept
            </Button>
            <Button
              variant="outlined"
              size="small"
              disabled={loading}
              onClick={() =>
                onRespond(invite.invite_id, invite.invite_target_type, false)
              }
            >
              Decline
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
